import React from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import { getCMSObject, TeleScript } from 'sg-ui-components';

import Layout from '../Components/Layout/Layout';
import PageTitle from '../Components/PageTitle.js';
import GameOver from '../Components/GameOver.js';
import UserLockout from '../userLockout';

import EntryInner from '../Components/Enter/EntryInner.js';

const EnterPage = ({ user, config, cmsSourceFirebase, actions }) => {
    const page = {
        title: getCMSObject('data.microsite.general.ticketEntry.pageInfo.pageTitle'),
        className: 'enter',
    };

    return (
        <Layout {...{ page, user, config, cmsSourceFirebase, actions }}>
            <UserLockout>
                {config?.config?.isGameOver === false ? (
                    <div className='entry-page-wrapper w-100'>
                        <div className='page-info'>
                            <PageTitle title={page?.title} />
                            <div className='description'>
                                <TeleScript line={getCMSObject('data.microsite.general.ticketEntry.pageInfo.pageDescription.contentHTML')} />
                            </div>
                            <div className='text-center'>
                                <TeleScript line={getCMSObject('data.microsite.general.ticketEntry.ticketEntryInstruction.contentHTML')} />
                            </div>
                        </div>
                        <EntryInner />
                    </div>
                ) : (
                    <GameOver />
                )}
            </UserLockout>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(EnterPage);
